// 默认请求异常提示
export const ERROR_DEFAULT_HTTP_REQUEST_FAIL = '请求失败'
